/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Curve_Max_LevelInputs */



/**
* | output |
* | --- |
* | "Highest level" |
*
* @param {Leveling_Curve_Max_LevelInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_curve_max_level = /** @type {((inputs?: Leveling_Curve_Max_LevelInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Curve_Max_LevelInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальный уровень")
	return /** @type {LocalizedString} */ ("Highest level")
});